import { useCallback, useEffect, useState } from 'react';
import { fetchCommentedOutputCount } from '../aiImageStudioApi';

let globalCount = 0;
const listeners = new Set<(count: number) => void>();

function notify(count: number) {
  globalCount = count;
  listeners.forEach((fn) => fn(count));
}

export function refreshAiCommentBadge() {
  fetchCommentedOutputCount()
    .then((count) => notify(count))
    .catch(() => {});
}

export function useAiCommentBadge(): number {
  const [count, setCount] = useState(globalCount);

  useEffect(() => {
    const handler = (c: number) => setCount(c);
    listeners.add(handler);

    refreshAiCommentBadge();
    const interval = setInterval(refreshAiCommentBadge, 60_000);

    return () => {
      listeners.delete(handler);
      clearInterval(interval);
    };
  }, []);

  return count;
}
